import { useLang } from "../i18n/LanguageContext";

const LanguageToggle = ({ variant = "default" }) => {
  const { lang, setLang } = useLang();
  const isBg = lang === "bg";

  const baseBtn =
    "font-body text-xs font-semibold tracking-[0.18em] uppercase px-2.5 py-1 rounded-sm transition-all duration-300";
  const activeCls = "bg-coral text-white";
  const idleCls =
    variant === "mobile"
      ? "text-ink-soft hover:text-navy"
      : "text-ink-soft hover:text-navy";

  return (
    <div
      data-testid="language-toggle"
      className={`inline-flex items-center gap-1 border border-navy/15 rounded-sm p-0.5 ${
        variant === "mobile" ? "w-fit" : ""
      }`}
      role="group"
      aria-label="Language toggle"
    >
      <button
        type="button"
        data-testid="lang-bg"
        onClick={() => setLang("bg")}
        aria-pressed={isBg}
        className={`${baseBtn} ${isBg ? activeCls : idleCls}`}
      >
        BG
      </button>
      <button
        type="button"
        data-testid="lang-en"
        onClick={() => setLang("en")}
        aria-pressed={!isBg}
        className={`${baseBtn} ${!isBg ? activeCls : idleCls}`}
      >
        EN
      </button>
    </div>
  );
};

export default LanguageToggle;
